import { ModalContent, ModalContentProps } from '@chakra-ui/react';
import React from 'react';

export const CmModalContent: React.FC<ModalContentProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <ModalContent {...rest}>{children}</ModalContent>;
};
